import { checkResolution } from "Functions/helpers";
import "Ui/tabs";
import "Components/navigation-menu-aim";

const navigationToggle = document.querySelector(".js-navigation-toggle");

if (navigationToggle) {
    navigationToggle.addEventListener("rToggle.afterOpen", function (event) {
        const navTabs = navigationToggle.querySelector(".js-aim-navigation");

        if (checkResolution("sm;md;lg") && navTabs.activeTabs.length < 1) {
            const firstTabId = navTabs.targets[0].getAttribute("id");

            navTabs.openTab(firstTabId);
        }
    });
}
